import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useMemo } from "react";
import FormRow from "components/form/FormRow";
import { useForm } from "react-final-form"
import IMV from "..";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Operador from "entity/Operador";
import Trator from "entity/Trator";
import SelectInput from "components/form/input/SelectInput";

export default function IMVEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(IMV, "Mecanizado", TipoClass), [visita.cliente])

    const [apontamento] = useFieldValue();
    const form = useForm()

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado")
        }
    }, [setTipo, tipo])

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = IMV.calcConformidade(apontamento, params);

            form.change("conformidade", IMV.calcConformidade(apontamento, params))
            form.change("apontamento.coletas", IMV.calcConformidade(apontamento, params))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} showImplemento={false} />

            <ApontamentoAmostraParams tipoFixedValue="Mecanizado">
                <FormRow>
                    <EntitySearchInput name="operador" label="Operador" EntityClass={Operador} extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)} />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="frota"
                        label="Frota"
                        EntityClass={Trator}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} />
                </FormRow>
            </ApontamentoAmostraParams >

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <FormRow>
                    <TextInput type="number" name="pesoTotal" label="Peso Total (kg)" />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="pesoPalhaKg" label="Peso Palha (kg)" />
                    <TextInput type="number" name="pesoPalhaPc" label="Peso Palha (%)" disabled />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="pesoPalmitoKg" label="Peso Palmito (kg)" />
                    <TextInput type="number" name="pesoPalmitoPc" label="Peso Palmito (%)" disabled />
                </FormRow>
            </ApontamentoColetas>

            <ApontamentoResultado>
                <FormRow>
                    <TextInput name="totalImpureza" label="Total Impureza (kg)" disabled />
                </FormRow>
                <FormRow>
                    <TextInput name="impurezaVegetal" label="Impureza Vegetal (%)" disabled />
                </FormRow>
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
